import { createAnonAxios } from "./vg2AnonAxios";

const API = createAnonAxios(
  `${process.env.REACT_APP_BACKEND_URL}/api/v2/property-advisor`,
);

export const getPaConsentCopy = async () =>
  (await API.get("/consent-copy")).data;

export const submitPaRequest = async (body) =>
  (await API.post("/requests", body)).data;

export const getPaRequestForCase = async (caseId) =>
  (await API.get(`/requests/case/${caseId}`)).data;

export const getPaReferralInfo = async (caseId) =>
  (await API.get(`/requests/case/${caseId}/referral-info`)).data;
